export default __webpack_public_path__ + "static/screeny-110-gc-7-60a5819ed8fe7b2075d7f76bbdab24ce.jpg";